const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");

const styles = require("./styles/EditPencil.css");

module.exports = createReactClass({
	displayName: "EditPencil",

	propTypes: {
		className: PT.string,
		onClick: PT.func,
		hidden: PT.bool,
		width: PT.number, // Optional width in rem. Aspect ratio will be preserved.
	},

	render: function() {
		let imgEl;

		const attr = {};
		const style = {};

		if (!this.props.hidden) {
			style.cursor = "pointer";
			attr.onClick = this.props.onClick;
			imgEl = (
				<svg
					width="38"
					height="38"
					viewBox="0 0 38 38"
					preserveAspectRatio="none"
					className={styles.editButton}
				>
					<g>
						<polygon points="30.6,14.1 30,13.5 29.4,12.9 24,7.5 5.3,26.1 12,32.8   " />
						<rect
							x="27.2"
							y="2.6"
							transform="matrix(0.7071 -0.7071 0.7071 0.7071 3.8511 23.9111)"
							width="7.1"
							height="9.4"
						/>
						<polygon points="1.4,36.5 11,33.5 4.4,26.9   " />
					</g>
				</svg>
			);
		}

		const {width, className} = this.props;

		if (width) {
			_.extend(style, {
				width: width + "rem",
				height: width + "rem",
			});
		}

		let mainClass = styles.editContainer;
		if (className) mainClass += " " + className;

		return (
			<div className={mainClass} style={style} {...attr}>
				{imgEl}
			</div>
		);
	},
});
